var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div> \n  <page-header>\n    <h1>\n      <div class=\"date\"><span class=\"weekday\">{{ distribution.date | moment:'llll' }}</span></div>\n      <div class=\"distr-no\">{{ t('distrNo' + distribution.distrNo) }}</div>\n      <div ng-repeat=\"name in customerSystemNames(distribution.routePlans)\" class=\"customer-system\">{{ name }}</div>\n    </h1>\n    <form ng-submit=\"searchForm.$valid &amp;&amp; goToSearch()\" name=\"searchForm\" class=\"actions\">\n      <input type=\"text\" ng-model=\"search.customer\" placeholder=\"{{ t('distributionCustomerSearch') }}\" ng-minlength=\"3\" required class=\"search\">\n      <button type=\"submit\" ng-disabled=\"searchForm.$invalid\" class=\"action\">{{ t('cSearch') }}</button>\n    </form>\n  </page-header>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/distributionHeader.jade
 ** module id = 70
 ** module chunks = 1
 **/